import { graphql } from "@/lib/gql/__generated__/gql";

export const VoucherForCampaignCreate_EditPage_Mutation = graphql(/* GraphQL */ `
	mutation VoucherForCampaignCreate_EditPage($input: VoucherForCampaignInput!) {
		voucherForCampaignCreate(input: $input) {
			userErrors
			voucherForCampaign {
				hotelID
				voucherID
				inSale
				name
				description
				mainKeyVisual {
					bucket
					key
					region
					mimeType
					fileName
				}
				voucherPrice {
					currencyType
					amount
				}
				resourceAvailablePrice {
					currencyType
					amount
				}
				voucherGiftList {
					guestName
					guestTel
					guestEmail
				}
				voucherExplanationForHost
				mailTemplate
				cinStart
				cinEnd
				createdAt
				deletedAt
			}
		}
	}
`);
